import { render, staticRenderFns } from "./acts_for_bill.vue?vue&type=template&id=212272a4&scoped=true&"
import script from "./acts_for_bill.vue?vue&type=script&lang=js&"
export * from "./acts_for_bill.vue?vue&type=script&lang=js&"
import style0 from "./acts_for_bill.vue?vue&type=style&index=0&id=212272a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212272a4",
  null
  
)

export default component.exports